// extracted by mini-css-extract-plugin
export default {"withoutDiscount":"FullPrice_withoutDiscount__3wWTG"};